const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the assignment template edit component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('editAssignmentTemplate', ['AssignmentTemplates', 'Features', 'Messaging', '$translate', function(AssignmentTemplates, Features, Messaging, $translate) {
  return {
    restrict: 'E',
    scope: {
      templateid: '=?',
      close: '&'
    },
    template: require('../../../templates/directives/assignments/edit-assignment-template.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      const self = this;
      self.assignmentTemplates = Features.flags().enable_assignment_templates;

      if (!self.assignmentTemplates) {
        Navigation.goToHome();
        return;
      }

      self.initialized = false;
      self.saving = false;

      self.tabs = {
        current: 'settings',
        order: ['settings', 'notifications'],
        showNext: function() {
          return self.tabs.current !== self.tabs.order[self.tabs.order.length - 1];
        },
        changeTab: function(direction) {
          const add = direction === 'next' ? 1 : -1;
          let place = self.tabs.order.indexOf(self.tabs.current);
          place = place === -1 ? 0 : place;
  
          self.tabs.current = self.tabs.order[place + add];
        },
        navigate: function(tab) {
          self.tabs.current = tab;
        }
      };

      if (!$scope.templateid) {
        self.tabs.order = ['settings', 'content', 'notifications'];
      }

      self.settings = {};
      self.content = [];

      self.addMessage = function(message) {
        // check if already in non_reminder_messages or reminder messages
        // check if type is appropriate for place
        // add to correct place
        var messageType = message.type.indexOf('reminder') !== -1 ? 'rm' : message.type.indexOf('overdue') !== -1 ? 'om' : 'nrm';
        var nrmPlace = self.settings.non_reminder_messages.indexOf(message._id);
        var rmPlace = -1;
        let omPlace = -1;
        for (const [i, rm] of self.settings.reminder_messages.entries()) {
          if (rm.message === message._id) {
            rmPlace = i;
            break;
          }
        }
        for (const [i, om] of self.settings.overdue_messages.entries()) {
          if (om.message === message._id) {
            omPlace = i;
            break;
          }
        }

        if (messageType === 'nrm') {
          if (nrmPlace === -1) {
            self.settings.non_reminder_messages.push(message._id);
          }
          if (rmPlace !== -1) {
            self.settings.reminder_messages.splice(rmPlace, 1);
          }
          if (omPlace !== -1) {
            self.settings.overdue_messages.splice(omPlace, 1);
          }
        }

        if (messageType === 'rm') {
          if (rmPlace === -1) {
            self.settings.reminder_messages.push({
              message: message._id,
              time_before_due: message.time_before_due
            });
          } else {
            self.settings.reminder_messages[rmPlace] = {
              message: message._id,
              time_before_due: message.time_before_due
            }
          }
          if (nrmPlace !== -1) {
            self.settings.non_reminder_messages.splice(nrmPlace, 1);
          }
          if (omPlace !== -1) {
            self.settings.overdue_messages.splice(omPlace, 1);
          }
        }

        if (messageType === 'om') {
          const overdueMessage = {
            message: message._id,
            cadence: message.cadence,
            total_messages: message.total_messages,
          };
          if (omPlace === -1) {
            self.settings.overdue_messages.push(overdueMessage);
          } else {
            self.settings.overdue_messages[omPlace] = overdueMessage;
          }
          if (rmPlace !== -1) {
            self.settings.reminder_messages.splice(rmPlace, 1);
          }
          if (nrmPlace !== -1) {
            self.settings.non_reminder_messages.splice(nrmPlace, 1);
          }
        }

      };

      self.initialize = async function() {
        if (!$scope.templateid) {
          self.settings = {
            title: '',
            days_to_complete: 30,
            non_reminder_messages: [],
            reminder_messages: [],
            overdue_messages: [],
            use_due: false,
            due_date: 30,
            due_from_hired: false,
            due_days_after_hired: 30,
            escalate_manager: false,
            escalate_buddy: false,
            escalation_contacts: [],
            require_recompletion: false
          };
          self.initialized = true;
          return;
        }

        const template = await AssignmentTemplates.get({subresource: $scope.templateid}).$promise;

        self.settings = {
          title: template.title || '',
          days_to_complete: self.settings.due_date,
          non_reminder_messages: template.non_reminder_messages || [],
          reminder_messages: template.reminder_messages || [],
          overdue_messages: template.overdue_messages || [],
          use_due: template.use_days_to_complete || false,
          due_date: template.days_to_complete || 30,
          due_from_hired: template.due_from_hired || false,
          due_days_after_hired: template.due_days_after_hired || 30,
          escalate_manager: template.escalate_manager || false,
          escalate_buddy: template.escalate_buddy || false,
          escalation_contacts: template.escalation_contacts || [],
          require_recompletion: template.require_recompletion || false
        };

        self.content = template.assigned_content.map(item => item.content_id);

        self.initialized = true;
        $scope.$apply();

      };

      const typeToModel = {
        article: 'Article',
        media: 'Media',
        video: 'Media',
        file: 'Media',
        scorm: 'ScormContent',
        imported_content: 'ImportedContent',
        assessment: 'Assessment',
        workshop: 'Workshop',
        journey: 'Journey',
        track: 'Track'
      };

      self.createTemplate = async function() {
        if (!self.settings.title) {
          Messaging.addMessage({type: 'error', duration: 6, text: self.translations['assignmentTemplates.update.error-title']});
          return;
        }
        if (!self.content || !self.content.length) {
          Messaging.addMessage({type: 'error', duration: 6, text: self.translations['assignmentTemplates.update.error-title']});
          return;
        }

        self.saving = true;

        const body =  {
          title: self.settings.title,
          days_to_complete: self.settings.due_date,
          use_days_to_complete: self.settings.use_due,
          due_from_hired: self.settings.due_from_hired,
          due_days_after_hired: self.settings.due_days_after_hired,
          escalation_contacts: self.settings.escalation_contacts,
          escalate_manager: self.settings.escalate_manager,
          escalate_buddy: self.settings.escalate_buddy,
          non_reminder_messages: self.settings.non_reminder_messages,
          reminder_messages: self.settings.reminder_messages,
          overdue_messages: self.settings.overdue_messages,
          require_recompletion: self.settings.require_recompletion
        };

        body.assigned_content = self.content.map(item => {
          return {
            content_type: typeToModel[item.type],
            content_id: item._id
          }
        });

        try {
          await AssignmentTemplates.create(body).$promise;
          self.close(true);
          Messaging.addMessage({type: 'success', duration: 6, text: self.translations['assignmentTemplates.create.success']});
        } catch (error) {
          Messaging.addMessage({type: 'error', duration: 6, text: self.translations['assignmentTemplates.create.error']});
          self.close();
        }

        self.saving = false;

      };

      self.saveChanges = async function() {

        if (!self.settings.title) {
          Messaging.addMessage({type: 'error', duration: 6, text: self.translations['assignmentTemplates.update.error-title']});
          return;
        }

        self.saving = true;

        const body =  {
          title: self.settings.title,
          days_to_complete: self.settings.due_date,
          use_days_to_complete: self.settings.use_due,
          due_from_hired: self.settings.due_from_hired,
          due_days_after_hired: self.settings.due_days_after_hired,
          escalation_contacts: self.settings.escalation_contacts,
          escalate_manager: self.settings.escalate_manager,
          escalate_buddy: self.settings.escalate_buddy,
          non_reminder_messages: self.settings.non_reminder_messages,
          reminder_messages: self.settings.reminder_messages,
          overdue_messages: self.settings.overdue_messages,
          require_recompletion: self.settings.require_recompletion
        };

        try {
          await AssignmentTemplates.update({subresource: $scope.templateid}, body).$promise;
          self.close(true);
          Messaging.addMessage({type: 'success', duration: 6, text: self.translations['assignmentTemplates.update.success']});
        } catch (error) {
          Messaging.addMessage({type: 'error', duration: 6, text: self.translations['assignmentTemplates.update.error']});
          self.close();
        }

        self.saving = false;

      };

      self.close = function(refresh) {
        $scope.close({changed: refresh});
      };

      $translate([
        'assignmentTemplates.update.success',
        'assignmentTemplates.update.error',
        'assignmentTemplates.update.error-title',
        'assignmentTemplates.create.error-content',
        'assignmentTemplates.create.success',
        'assignmentTemplates.create.error'
      ]).then(function(translations){
        self.translations = translations;
      });

      self.initialize();

    }],
    controllerAs: 'editTemplate'
  };
}]);
